export const getServiceTypeFromTkType = (tkType) => {
  if (Number(tkType) === 0) return 1;
  if (Number(tkType) === 2) return 2;

  return 0;
};

export const applyServiceTypePrices = (value, tkType) => {
  const serviceType = getServiceTypeFromTkType(tkType);

  const updatePrice = (currentValue) => {
    if (Array.isArray(currentValue)) {
      return currentValue.map(updatePrice);
    }

    if (!currentValue || typeof currentValue !== "object") {
      return currentValue;
    }

    const updatedValue = Object.keys(currentValue).reduce((result, key) => {
      result[key] = updatePrice(currentValue[key]);
      return result;
    }, {});
    const servicePrice = Array.isArray(currentValue.priceList)
      ? currentValue.priceList.find((price) => Number(price.serviceType) === serviceType)
      : null;

    if (servicePrice && servicePrice.price != null && typeof servicePrice.price !== "undefined" &&
      typeof updatedValue.addPrice !== "undefined" && updatedValue.addPrice != null
    ) {
      updatedValue.addPrice = servicePrice.price;
    } else if (servicePrice && servicePrice.price !== null && typeof servicePrice.price !== "undefined" &&
      updatedValue.price != null && typeof updatedValue.price !== "undefined"
    ) {
      updatedValue.price = servicePrice.price;
    }
    return updatedValue;
  };

  return updatePrice(value);
};
